module.exports = __webpack_public_path__ + "img/pic2.9049ad7c.png";